import React from 'react'
import { BasicCard } from '../index'
import colors from '../../utils/colors'
import { useViewport, viewportBreakpoint } from '../../utils'

const HorizontalBarChart = ({data}) => {
  const locationData = data
  const { width } = useViewport()
  const breakpoint = viewportBreakpoint.tablet
  const isMobile = width < breakpoint
  const barWidth = isMobile ? '2px' : '5px'

  return (
    <BasicCard>
      <p className="text-lg font-bold font-accent mb-5 uppercase">Location</p>
      {
        locationData.data.map((d, index) => (
          <div className="flex justify-between items-center mb-2" key={index}>
            <div className="w-1/2 md:w-1/3 lg:w-full text-sm text-gray-444">
              {(d.value/locationData.total*100).toFixed(0)}% - {d.name} ({d.value})
            </div>
            <div className="w-1/2 md:w-2/3 lg:w-full pl-4 lg:pl-0">
              <div className="relative" style={{maxWidth: '185px'}}>
                <hr
                  className="absolute z-20 left-0 rounded-lg"
                  style={{top: '50%', transform: 'translateY(-50%)', borderColor: colors.green, borderWidth: barWidth, width: `${(d.value/locationData.total*100)}%`}}
                />
                <hr
                  className="absolute w-full z-10 left-0 rounded-lg"
                  style={{top: '50%', transform: 'translateY(-50%)', borderColor: '#eee'}}
                />
              </div>
            </div>
          </div>
        ))
      }
    </BasicCard>
  )
}

export { HorizontalBarChart }